import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './auth';
import Donate from './pages/Donate';
import ReportSlip from './pages/ReportSlip';
import History, { DonationDone } from './pages/History';
import HelpRequest from './pages/HelpRequest';
import TrackRequest from './pages/TrackRequest';

function AuthError({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="splash">
      <div style={{ fontSize: 44 }}>⚠️</div>
      <h1 style={{ fontSize: 20, margin: 0 }}>เชื่อมต่อไม่สำเร็จ</h1>
      <p className="muted">
        อาจเกิดจากสัญญาณอินเทอร์เน็ตไม่เสถียร
        <br />
        กรุณาลองใหม่อีกครั้ง
      </p>
      <button onClick={onRetry}>ลองใหม่</button>
    </div>
  );
}

/**
 * หน้าที่ไม่ต้องล็อกอิน
 *
 * คนที่มาขอความช่วยเหลือมักเป็นผู้สูงอายุและใช้มือถือร่วมกับลูกหลาน
 * ถ้าให้รอผูกบัญชี LINE ให้เสร็จก่อน เขาจะไม่ได้ยื่นจริง — สองหน้านี้จึงต้อง
 * เปิดได้แม้ตอนที่ระบบยังเชื่อมต่อ LINE ไม่เสร็จหรือเชื่อมไม่สำเร็จ
 */
const PUBLIC_PATHS = ['/help', '/track'];

export default function App() {
  const { status, retry } = useAuth();
  const { pathname } = useLocation();

  const isPublic = PUBLIC_PATHS.some((p) => pathname.startsWith(p));

  if (!isPublic) {
    if (status.kind === 'loading') return <div className="center">กำลังเชื่อมต่อ…</div>;
    if (status.kind === 'error') return <AuthError onRetry={retry} />;
  }

  return (
    <Routes>
      <Route path="/help" element={<HelpRequest />} />
      <Route path="/track" element={<TrackRequest />} />
      <Route path="/" element={<Donate />} />
      <Route path="/donate" element={<Donate />} />
      <Route path="/slip" element={<ReportSlip />} />
      <Route path="/history" element={<History />} />
      <Route path="/done" element={<DonationDone />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
